import { render, staticRenderFns } from "./upversion.vue?vue&type=template&id=43856d12&scoped=true&"
import script from "./upversion.vue?vue&type=script&lang=js&"
export * from "./upversion.vue?vue&type=script&lang=js&"
import style0 from "./upversion.vue?vue&type=style&index=0&id=43856d12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43856d12",
  null
  
)

export default component.exports